

import React, { useState} from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { Game } from './Game.jsx'

// Modul-level cache da se na svakom open/close searcha ne pokreće novi HTTP request za igre, kategorije i teme. 
// Drži Promise koji se resolvea kad server odgovori, i onda se taj isti Promise reusea na svim mountovima dokle 
// god je validan (nije null). Ako server request faila, cache se čisti da se može pokušati ponovo na idući mount.
let _searchDataPromise = null;
function getSearchData(saveCategoriesFn) {
    if (_searchDataPromise) return _searchDataPromise;
    _searchDataPromise = Promise.all([
        casino.repos.gameRepo.list(),
        casino.repos.categoryRepo.list().then(saveCategoriesFn),
        casino.repos.casinoThemesRepo.list(true)
    ]).catch(err => {
        _searchDataPromise = null;
        throw err;
    });
    return _searchDataPromise;
}

export class GameSearchResults extends React.Component {
    constructor(props) {
        super(props);
        this.state = { igre: null, gamesFromFilter: [] }

        this.setData = this.setData.bind(this);
        this.renderIgra = this.renderIgra.bind(this);
        this.popraviVisinu = this.popraviVisinu.bind(this);
        this.gamesContainer = React.createRef();
        this.renderRandomGame = this.renderRandomGame.bind(this);
        this.onFilterClose = this.onFilterClose.bind(this);
        this.updateFilter = this.updateFilter.bind(this);
        this.setHistoryFilters = this.setHistoryFilters.bind(this);

        //window.addEventListener('resize', this.popraviVisinu);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.searchValue != nextProps.searchValue || !this.state.igre;
    }


    componentDidMount() {
        //window.scroll(0, 0);
        this._isMounted = true;
        this.props.showSearchFn(true);

        this.dataPromises = casino.utils.makeCancelablePromise(getSearchData(this.props.saveCategoriesFn));
        this.dataPromises.promise.then(this.setData, function (reason) { });

        if (this.props.autoShowRandomGame == true) {
            this._autoShowRandomGameTimer = setTimeout(() => {
                this._autoShowRandomGameTimer = null;
                if (!this._isMounted) return;
                var btn = document.getElementById('iznenadi-me');
                if (btn) btn.click();
            }, 400);
            this.props.autoShowRandomGameFn(false);
        }

        this.popraviVisinu();

    }

    componentDidUpdate() {
        this.popraviVisinu();
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this._popraviVisinuTimer) {
            clearTimeout(this._popraviVisinuTimer);
            this._popraviVisinuTimer = null;
        }
        if (this._autoShowRandomGameTimer) {
            clearTimeout(this._autoShowRandomGameTimer);
            this._autoShowRandomGameTimer = null;
        }

        this.props.showSearchFn(false);
        if (this.dataPromises) this.dataPromises.cancel();

        //window.removeEventListener('resize', this.popraviVisinu);

        var searchResults = document.getElementsByClassName("search-results")[0];
        if (searchResults) searchResults.style.height = '';
        var searchShown = document.getElementsByClassName("search-shown")[0];
        if (searchShown) searchShown.style.height = '';
        var appEl = document.getElementById("app");
        if (appEl) appEl.style.paddingBottom = '';
        var footerEl = document.getElementById("footer");
        if (footerEl) footerEl.style.display = '';
        this.props.refreshRandomGameFn(false);
    }

    setData(data) {
        var [igre, kategorije, teme] = data;
        this.setState({
            igre: igre.items,
            brands: igre.brendovi,
            categories: kategorije.items,
            themes: teme
        });
    }

    renderIgra(igra, index) {
        const imaFiltere =
            this.props.filterSelectedCategories?.length > 0 ||
            this.props.filterSelectedProviders?.length > 0 ||
            this.props.filterSelectedThemes?.length > 0 ||
            this.props.filterSelectedSpecialFilters?.length > 0;

        const imaSearch = this.props.searchValue && this.props.searchValue.length > 0;

        // GamePosition logika, gleda se da li je pozicija cisti filter, search ili oboje, ako oboje onda filter prevladava, HizmanB
        const positionType = imaFiltere ? "filter" : (imaSearch ? "search" : "filter");

        return <Game
            brands={this.props.brands}
            categories={this.state.categories}
            from="search"
            key={igra.s}
            showJackpot={true}
            routePrefix={this.props.routePrefix}
            igra={igra}
            gameNameClass=""
            // GamePosition podaci, HizmanB
            PageName="Search"
            GamePosition={index + 1}
            PositionType={positionType}
            ComponentName={"search-result"}
            SearchValue={this.props.searchValue}
            FilterValue={{
                Kategorije: this.props.filterSelectedCategories.map(cat => cat.name).join(','),
                Provideri: this.props.filterSelectedProviders.map(prov => prov).join(','),
                Teme: this.props.filterSelectedThemes.map(tema => tema.sifra).join(','),
                Odabrano: this.props.filterSelectedSpecialFilters.map(s => s).join(','),
                Search: this.props.searchValue
            }}
        />

    }

    onFilterClose(/*result*/) {
        // if (result.games) {
        //     this.setState({gamesFromFilter: result.games,});
        // } else {
        //     this.setState({gamesFromFilter: []});
        // }
        this.forceUpdate();
    }

    popraviVisinu() {
        if (this._popraviVisinuTimer) {
            clearTimeout(this._popraviVisinuTimer);
        }
        this._popraviVisinuTimer = setTimeout(() => {
            this._popraviVisinuTimer = null;
            if (!this._isMounted) return;

            var elmnt = this.gamesContainer.current;
            if (!elmnt) return;

            var height = elmnt.offsetHeight + 200 + 50;
            if (height < screen.height)
                height = screen.height;

            var searchResults = document.getElementsByClassName("search-results")[0];
            if (searchResults) searchResults.style.height = height.toString() + 'px';
            var searchShown = document.getElementsByClassName("search-shown")[0];
            if (searchShown) searchShown.style.height = height.toString() + 'px';
            var appEl = document.getElementById("app");
            if (appEl) appEl.style.paddingBottom = '0px';
            var footerEl = document.getElementById("footer");
            if (footerEl) footerEl.style.display = 'none';
        }, 100);
    }

    updateFilter(type, item) {
        let categories = this.props.filterSelectedCategories;
        let providers = this.props.filterSelectedProviders;
        let themes = this.props.filterSelectedThemes;
        let specialFilters = this.props.filterSelectedSpecialFilters;
        if (type == "c") {
            categories = categories.filter(it => it.id != item.id);
        }
        if (type == "p") {
            providers = providers.filter(it => it != item);
        }
        if (type == "t") {
            themes = themes.filter(it => it.sifra != item.sifra);
        }
        if (type == "s") {
            specialFilters = specialFilters.filter(it => it =! item);
        }
        this.props.setActiveFiltersFn(categories, providers, themes, specialFilters);

        setTimeout(() =>  {
            this.props.filterGamesFn(this.state.igre);
            this.forceUpdate();
        }, 0); 
        
    }

    setHistoryFilters(history) {
        this.props.setActiveFiltersFn(
            history.categories.length > 0 ? this.state.categories.filter(it => history.categories.filter(x => x == it.id).length > 0):[], 
            history.providers.length > 0 ? Object.keys(this.state.brands).filter(it => history.providers.filter(x => x == it).length > 0):[],
            history.themes.length > 0 ? this.state.themes.filter(it => history.themes.filter(x => x == it.sifra).length > 0):[],
            history.specialFilters?.length > 0 ? history.specialFilters : []
        );
        setTimeout(() => {
            this.props.filterGamesFn(this.state.igre);
            this.forceUpdate();
        }, 0); 
    }

    renderRandomGame() {
        let game;
        if (this.state.igre) {
            game = casino.utils.getRandomGame(this.state.igre, 
                this.props.user ?  this.props.user.zadnjeIgrano : null, 
                this.props.user ? this.props.user.najigranije : null, "1", "2");
        }
        return <>
            <div className="action-buttons">
                    {this.props.brands && game && <NavLink onClick={() => {this.props.showSearchFn(false); setTimeout(() => {this.props.showSearchFn(true, null, false); this.props.refreshRandomGameFn(true);}, 0);}} to={{
                    pathname: ((this.props.routePrefix || '') + '/').replace('//', '/') + 'game/' + this.props.brands[game.bID].nameNormalizirano + "/" + casino.utils.normalizeString(game.n), 
                        query: {
                            game: casino.utils.normalizeString(game.n),
                            from: (this.props.from || ''),
                            // GamePosition podaci, HizmanB
                            PageName: "Search",
                            PositionType: "suprise_me"
                            }
                        }}>
                        <div className="btn-gray surprise" id="iznenadi-me">
                            {/* <img className="hand-img" src="content/images/assets/ruka_1.png" ></img> */}
                            Iznenadi me
                        </div>
                    </NavLink>}
                    {this.state.igre && <div className="btn-gray filter" onClick={() =>  this.props.showPopUpFn(true, "homepage-filter", this.onFilterClose, 
                            {games: this.state.igre, categories: this.state.categories, themes:this.state.themes, brands: this.state.brands})}>
                        Filter
                    </div>}

                {/* <div className="what-to-play-text">Zavrtit ćemo sve igre na SuperSport Casinu i ponuditi ti nešto jako zanimljivo! Iznenadi se!</div> */}
            </div>
            {this.props.historyFilters?.length > 0 && this.props.filteredGames.length == 0 && this.props.historyFilters.slice(0,3).map((history, i) => {
                return <React.Fragment key={"history"+i}>
                        {history.date != null && <div  className="recent-history-item filter-item" onClick={() => this.setHistoryFilters(history)}>Filter - {history.date}</div>}
                        {history.date == null && <div  className="recent-history-item search-item" onClick={() =>this.props.onSearchChange(history.text)}>Pretraga - {history.text}</div>}
                        <div style={{"clear":"both"}}></div>
                    </React.Fragment>
            })}
            <div style={{"clear":"both"}}></div>
        </>
    }

    renderActiveFilters() {
        return <>
                   <h3>Rezulati filtriranja</h3>
                   <div style={{'clear':'both"'}}></div>
                   <span className="clear-all" onClick={()=> {this.props.setActiveFiltersFn([],[],[],[]); setTimeout(() => {this.props.filterGamesFn();this.forceUpdate();}, 0);}}>
                        <span className="icon"></span>
                    </span>
                   <div className="active-filters">                       
                        {this.props.filterSelectedProviders.map((providerID, index) => {
                            return <span className={"active-filter-item f-provider"} key={index + "active-filter-provider"}>
                                <span className={"image ff-provider p_" + casino.utils.normalizeString(this.props.brands[providerID].name)}></span>
                                <span></span>
                                <span className="close" onClick={() => this.updateFilter('p', providerID)}></span>
                            </span>
                        })}
                        {this.props.filterSelectedThemes.map((theme, index) => {
                            return <span className={"active-filter-item f-theme"} key={index+"active-filter-theme"}>
                                <span className={"image "+casino.utils.normalizeString(theme.naziv)}></span>
                                <span className="title theme">{theme.naziv}</span>
                                <span className="close" onClick={() => this.updateFilter('t', theme)}></span>
                            </span>
                        })}
                {this.props.filterSelectedSpecialFilters?.map((filter, index) => {
                    return <span className={"active-filter-item f-category"} key={index + "active-filter-theme"}>
                        <span className={"image " +
                            (filter == 1 ? "moje-zadnje-odigrano" :
                                filter == 2 ? "moje-najomiljenije" :
                                    filter == 3 ? "ekskluzivno" :
                                        filter == 4 ? "najnovije" :
                                            filter == 5 ? "respin" :
                                                filter == 6 ? "megaways" :
                                                    filter == 7 ? "bonus-buy" :
                                                        filter == 8 ? "hold-and-win" :
                                                            filter == 9 ? "jackpot-cards" :
                                                                filter == 10 ? "bell-link" :
                                                                    filter == 11 ? "golden-coins-link" :
                                                                        filter == 12 ? "barlink" :
                                                                            filter == 13 ? "jackpot-rain-filter" :
                                                                                filter == 14 ? "egypt-quest" :
                                                                                    filter == 15 ? "golden-nights-bonus" :
                                                                                        filter == 16 ? "red-hot-fire-pot" :
                                                                                            filter == 17 ? "gameart-jackpot" :
                                                                                                filter == 18 ? "clover-chance" :
                                                                                                    filter == 19 ? "zadano" : "")
                        }></span>
                        <span className="title">{filter == 1 ? "Moje zadnje odigrano" :
                            filter == 2 ? "Moje najomiljenije" :
                                filter == 3 ? "Ekskluzivno" :
                                    filter == 4 ? "Najnovije" :
                                        filter == 5 ? "Respin" :
                                            filter == 6 ? "Megaways" :
                                                filter == 7 ? "Bonus Buy" :
                                                    filter == 8 ? "Hold & Win" :
                                                        filter == 9 ? "Jackpot Cards" :
                                                            filter == 10 ? "Bell Link" :
                                                                filter == 11 ? "Golden Coins Link" :
                                                                    filter == 12 ? "Barlink" :
                                                                        filter == 13 ? "Jackpot Rain" :
                                                                            filter == 14 ? "Egypt Quest" :
                                                                                filter == 15 ? "Golden Nights Bonus" :
                                                                                    filter == 16 ? "Red Hot Fire Pot" :
                                                                                        filter == 17 ? "Gameart Jackpot" :
                                                                                            filter == 18 ? "Clover Chance" :
                                                                                                filter == 19 ? "Zadano" : ""}</span>
                        <span className="close" onClick={() => this.updateFilter('s', filter)}></span>
                    </span>
                        })}
                         {this.props.filterSelectedCategories.map((category, index) => {
                            return <span className={"active-filter-item f-category"} key={index+"active-filter-category"}>
                                        <span className={"image "+casino.utils.normalizeString(category.name)}></span>
                                        <span className="title">{category.name}</span>
                                        <span className="close" onClick={() => this.updateFilter('c', category)}></span>
                                    </span>
                        })}
                        <div style={{"clear":"both"}}></div>
                   </div>
                  
               </>
    }

    render() {

        let igre = [];
        let brands = {};
        let tags = [];
        if (this.props.filteredGames.length > 0) {
            igre = this.props.filteredGames;
        } else {
            igre =  this.state.igre;
        }
        if (this.props.brands) brands = this.props.brands;
        if (this.props.tags) tags = this.props.tags;
        var isNumber = function (n) {
            return !isNaN(parseFloat(n)) && isFinite(n);
        }

        var searchValue = (this.props.searchValue || '').toLowerCase();

        var filteredGames = tags && brands && igre && igre.filter((x) => {
            var igraTag = [];
            if(x.t) Object.keys(x.t).map(key => igraTag.push(tags[key]));
            var toSearch = igraTag || []; 
            if (x.kt && this.state.categories) Object.keys(x.kt).map(key => toSearch.push(this.state.categories.find(it => it.id == key).name.toLowerCase()));

                  
            toSearch.push(x.n.toLowerCase());
            toSearch.push(brands[x.bID].name.toLowerCase());

            var searchValuesTemp = searchValue.split(' ');
            var searchValues = [];

            // moramo spojiti broj i string poslije , recimo 20 linija
            for (let i = 0; i < searchValuesTemp.length; i++) {
                var value = searchValuesTemp[i];
                var valueAfter = searchValuesTemp[i + 1] || '';
                if (isNumber(value)) {
                    searchValues.push((value + ' ' + valueAfter).trim());
                    i++;
                } else {
                    searchValues.push(value);
                }
            }

            let pronadeno = 0;

            for (let searchIndx in searchValues) {          
                let search = searchValues[searchIndx];
                for (let tagIndx in toSearch) {
                    let tag = toSearch[tagIndx];

                    if (tag.indexOf(search) >= 0) {
                        pronadeno++;
                        break;
                    }
                }
            }

            return pronadeno == searchValues.length;
        });


        if (searchValue.length >=2 && filteredGames && filteredGames.length > 0 && this.props.filterSelectedCategories.length == 0 && this.props.filterSelectedProviders.length == 0 && this.props.filterSelectedThemes.length == 0) {
            let storedFilters = JSON.parse(localStorage.getItem("stored-filters"));
            let save = {text:searchValue}
            if (!storedFilters) {
                storedFilters = [save]
            } else {
                let add = true;        
                storedFilters.filter(it => it.date == null).every(item => {
                    if (item.text == save.text) {   
                        add = false;
                        return false;
                    } else {
                        return true;
                    }
                });
    
                if (add) storedFilters.unshift(save);
                if (storedFilters.length > 6) storedFilters.length = 6;
            }
            this.props.setHistoryFiltersFn(storedFilters);
            localStorage.setItem("stored-filters", JSON.stringify(storedFilters));
        }
    
        return <div className="clearfix games-container no-padding" ref={this.gamesContainer}>
            <div>
                {(searchValue.length < 2 || this.props.filteredGames.length > 0) && this.renderRandomGame()}
                {(this.props.filterSelectedCategories?.length > 0 || this.props.filterSelectedProviders?.length > 0 || this.props.filterSelectedThemes?.length > 0 || this.props.filterSelectedSpecialFilters?.length > 0) && this.renderActiveFilters()} 
                {(searchValue.length >= 2) && !this.state.igre && <div>Dohvaćam igre...</div>}
                {(searchValue.length >= 2) && this.state.igre && !filteredGames.length && <div className="no-results">Nema rezultata.</div>}
                {(searchValue.length >= 2 || this.props.filteredGames.length > 0) && this.state.igre && filteredGames.sort((x, y) => { return x.n > y.n }).map(this.renderIgra)}
            </div>
        </div>

    }
};
